import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  @media screen and (max-width: 425px) {
    font-size: 10px;

    .sharing {
      font-size: 20px !important;
    }
  }
`